import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  ConversationEvaluationResponse,
  ConversationInsightsResponse,
} from "./ConversationView.model";

export function useConversationViewApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getConversationInsights: (conversationId: string) =>
        apiResolver<ConversationInsightsResponse>(
          api.get(`platform/conversation-view/${conversationId}/insights`)
        ),
      getConversationEvaluation: (conversationId: string) =>
        apiResolver<ConversationEvaluationResponse>(
          api.get(`platform/conversation-view/${conversationId}/evaluation`)
        ),
    }),
    [api]
  );
}
